<footer class="footer-area">
    <div class="divider"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <p>Experience the high calibre of our services and get to know more about our innovative products.
                        If you're already our client or customer, use these links to help us serve you better and build
                        better partnerships.</p>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Company</h3>
                    <ul class="services-list">
                        <!-- <li><a routerLink="/about">About Us</a></li> -->
                        <li><a routerLink="/services" routerLinkActive="active">Services</a></li>
                        <!-- <li><a routerLink="/proucts">Products</a></li> -->
                        <li><a routerLink="/showcase" routerLinkActive="active">Showcase</a></li>
                        <li><a routerLink="/ventures/fort-mart" routerLinkActive="active">Fort Mart</a></li>
                        <!-- <li><a routerLink="/">Latest News</a></li> -->
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Support</h3>
                    <ul class="support-list">
                        <li><a routerLink="/contact" routerLinkActive="active">Contact &amp; Customer Care</a></li>
                        <li><a routerLink="/privacy-policy" routerLinkActive="active">Privacy Policy</a></li>
                        <li><a routerLink="/terms-conditions" routerLinkActive="active">Terms &amp; Conditions</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Contact Info</h3>
                    <ul class="footer-contact-info">
                        <!-- <li>Location</li> -->
                        <li>Operations Office:</li>
                        <li><a href="https://www.google.com/maps/place/Webstazy+One/@6.8840734,79.9030667,15z/data=!4m12!1m6!3m5!1s0x0:0x5bb51ec10c87d5e2!2sWebstazy+One!8m2!3d6.8840734!4d79.9030667!3m4!1s0x0:0x5bb51ec10c87d5e2!8m2!3d6.8840734!4d79.9030667"
                                target="_blank" rel="noopener noreferrer">34, Thalawathugoda Road, Pitakotte 10100, Sri Lanka</a></li>
                        <li class="office-label">Corporate Office:</li>
                        <li><a href="https://www.google.com/maps/search/?api=1&amp;query=55%2F1+Flower+Road+Colombo+07+Sri+Lanka"
                                target="_blank" rel="noopener noreferrer">55/1, Flower Road, Colombo 07 00700, Sri Lanka</a></li>
                        <li class="office-label">Email: <a href="mailto:info&#64;webstazy.one">info&#64;webstazy.one</a></li>
                        <li>Phone: <a href="tel:+94112186555">0112 186 555</a></li>
                    </ul>
                    <ul class="social">
                        <li><a href="https://twitter.com/WebstazyOne" target="_blank" rel="noopener noreferrer"
                                aria-label="Webstazy One on Twitter"><i class="bx bxl-twitter" aria-hidden="true"></i></a></li>
                        <li><a href="https://www.facebook.com/webstazyone" target="_blank" rel="noopener noreferrer"
                                aria-label="Webstazy One on Facebook"><i class="bx bxl-facebook" aria-hidden="true"></i></a></li>
                        <li><a href="https://www.linkedin.com/company/webstazy-one/" target="_blank" rel="noopener noreferrer"
                                aria-label="Webstazy One on LinkedIn"><i class="bx bxl-linkedin" aria-hidden="true"></i></a></li>
                        <li><a href="https://www.instagram.com/webstazy_one/" target="_blank" rel="noopener noreferrer"
                                aria-label="Webstazy One on Instagram"><i class="bx bxl-instagram" aria-hidden="true"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="copyright-area">
            <p>&copy;2017 - {{ currYear }} Webstazy One.</p>
        </div>
    </div>
</footer>

<button type="button" class="go-top" aria-label="Back to top"><i class='bx bx-chevron-up' aria-hidden="true"></i></button>